module.exports = __webpack_public_path__ + "img/v2-redesign-dashboard.a47ad6a7.png";